import { styled } from '@sds-system/system';
import { Column } from '../Column';

export const SnbContainer = styled(Column)`
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  overflow-x: hidden;
`;

export const ListColumn = styled(Column)`
  overflow-y: hidden;
  transition: max-height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  overflow-x: hidden;
`;
